export interface INotifier {
    log?(options: {
        exception: string;
        category?: string;
        code?: string;
        message?: string;
        data?: Record<string, any>;
    }): void;
    show?(options: {
        status?: Status;
        title: string;
        message?: string;
        duration?: number;
        progress?: number;
        action?: LinkAction | FunctionAction;
        detail?: {
            isHardError: boolean;
            isReportable?: boolean;
            isConnectionError?: boolean;
            baseUrl: string;
            url: string;
            error?: unknown;
        };
    }): void;
}

export enum Status {
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Error = 'critical',
}

export interface LinkAction {
    label: string;
    link: string;
}

export interface FunctionAction {
    label: string;
    onClick(): void;
}
